module.exports = __webpack_public_path__ + "static/media/iconEvaluationF.15152ccb.svg";